<template>
  <ValidationObserver ref="phoneNumber">
    <div>
      <div>
        <h2 class="mb-0">
          What is your phone number?
        </h2>
      </div>
      <ValidationProvider v-slot="{ errors }" name="phone" rules="required">
        <v-text-field
          :error-messages="showValidationErrors ? errors : ''"
          v-model="phone"
          class="mt-2"
          type="tel"
        />
      </ValidationProvider>
    </div>
    <div class="d-flex justify-end">
      <PrimaryButton @click.native="nextStep" :loading="isEditingUserDetails">
        {{ submitButtonTitle || "Continue" }}
      </PrimaryButton>
    </div>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { AUTH_NAMESPACE } from "@/store/modules/auth";
import { USERS_NAMESPACE } from "@/store/modules/users";

const { mapState: mapAuthState } = createNamespacedHelpers(AUTH_NAMESPACE);

const { mapState: mapUserState } = createNamespacedHelpers(USERS_NAMESPACE);

export default {
  name: "PhoneNumber",
  props: {
    submitButtonTitle: String
  },
  components: {
    PrimaryButton,
    ValidationProvider,
    ValidationObserver
  },
  async created() {
    this.phone = this.self.phone;
  },
  data() {
    return {
      phone: "",
      showValidationErrors: false
    };
  },
  computed: {
    ...mapUserState(["isEditingUserDetails"]),
    ...mapAuthState({
      self: state => state.userData
    })
  },
  methods: {
    async nextStep() {
      const isValid = await this.$refs.phoneNumber.validate();
      this.showValidationErrors = true;
      if (isValid) {
        this.$emit("nextStep", {
          data: {
            phone: this.phone
          }
        });
      }
    }
  }
};
</script>

<style lang="scss"></style>
